import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  useToast,
} from '@chakra-ui/react';
import { addRole } from '../api/auth';
import { getApiErrorMessage } from '../utils/apiError';

const AddGroupModal = ({ isOpen, onClose, refetch }) => {
  const [groupName, setGroupName] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (isOpen) {
      setGroupName('');
      setDescription('');
      setIsSaving(false);
    }
  }, [isOpen]);

  const handleSave = async () => {
    if (!groupName.trim()) {
      toast({
        title: 'Error',
        description: 'Group name is required.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsSaving(true);
    try {
      await addRole(groupName.trim(), description.trim());
      toast({
        title: 'Group Created',
        description: 'Group has been successfully created.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      refetch();
      onClose();
    } catch (error) {
      console.error('Error creating group:', error);
      toast({
        title: 'Error',
        description: getApiErrorMessage(
          error,
          error.response?.status === 400
            ? 'A group with this name already exists.'
            : 'Failed to create group.'
        ),
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add Group</ModalHeader>
        <ModalBody>
          <FormControl mb={3} isRequired>
            <FormLabel>Group Name:</FormLabel>
            <Input
              value={groupName}
              onChange={e => setGroupName(e.target.value)}
              placeholder="e.g. Operators"
              autoFocus
            />
          </FormControl>

          <FormControl mb={3}>
            <FormLabel>Description:</FormLabel>
            <Input
              value={description}
              onChange={e => setDescription(e.target.value)}
              placeholder="Enter description"
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={handleSave}
            isLoading={isSaving}
          >
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddGroupModal;
